import { LocationIcon } from 'cokitchen-icons';
import { LocationObjectType } from 'models/location.model';
import React from 'react';

type Props = {
  address: LocationObjectType;
  selectedAddress: LocationObjectType | undefined;
  setSelectedAddress: (address: LocationObjectType) => void;
  isSettings?: boolean;
};
const AddressItem = ({ address, selectedAddress, setSelectedAddress, isSettings }: Props) => {
  return (
    <div
      className='w-full flex items-center justify-between gap-3 py-[18px] border-b-[0.8px] border-b-[#E7E8E9] cursor-pointer'
      onClick={() => setSelectedAddress(address)}>
      <div className='flex gap-3 items-center w-[90%] select-none'>
        <LocationIcon />
        <div className='w-[65%]'>
          {!isSettings && (
            <p className='text-[#2E3031] text-sm font-medium capitalize'>{address.name}</p>
          )}

          {isSettings ? (
            <p className='text-[#5E6164] text-sm line-clamp-1 capitalize'>
              {address.name === null ? 'Other' : address.name}(
              {`
                     ${address.street_number !== null ? `${address.street_number}, ` : ''}${
                address.address
              }
                      `}
              )
            </p>
          ) : (
            <p className='text-[#5E6164] text-sm line-clamp-1 capitalize'>
              {`
                     ${address.street_number !== null ? `${address.street_number}, ` : ''}${
                address.address
              }
                      `}
            </p>
          )}
        </div>
      </div>
      <div className='flex gap-4 justify-between'>
        <span
          className={`ml-auto w-[14px] h-[14px] rounded-full ${
            selectedAddress === address
              ? 'border-[3.8px] border-[#E60A2B]'
              : 'border-[1.3px] border-[#D6D8E0]'
          }`}
        />
      </div>
    </div>
  );
};

export default AddressItem;
